import store from '@/app/shared/state/index';

import { redirectToIdp } from '@/common/oauth';

let initPromise = null;

const ensureInit = () => {
  if (!initPromise) {
    initPromise = store.dispatch('auth/oidc/initAuth');
  }
  return initPromise;
};

export const routes = [
  {
    path: '/auth',
    beforeEnter: (to) => {
      redirectToIdp(to.query.returnUrl);
      return false;
    },
    component: () => import('@/app/modules/auth/views/CallbackComponent.vue'),
    meta: { isProtected: false },
  },
  {
    path: '/login',
    beforeEnter: (to) => {
      redirectToIdp(to.query.returnUrl);
      return false;
    },
    component: () => import('@/app/modules/auth/views/CallbackComponent.vue'),
    meta: { isProtected: false },
  },
  {
    path: '/auth/callback',
    name: 'Callback',
    component: () => import('@/app/modules/auth/views/CallbackComponent.vue'),
    meta: { isProtected: false },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/app/modules/auth/views/LogoutComponent.vue'),
    meta: { isProtected: false },
  },
];

export const registerGuards = (router) => {
  router.beforeEach(async (to /*, from*/) => {
    await ensureInit();
    if (to.meta?.isProtected === true && !store.getters['auth/oidc/isAuthenticated']) {
      return { path: '/login', query: { returnUrl: to.fullPath } };
    }
    // console.log('auth guard', to, from)
  });
};
